import 'svelte/store';
class SocketServiceInit {
    constructor() {
        this.login = null;
        this.chat = null;
        this.notifyUser = null;
        this.modifyProfile = null;
        this.reaction = null;
    }
}
export const SocketService = new SocketServiceInit();
